import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { cn } from './cn'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './components/tooltip'

export function KbTooltip({
  children,
  tooltip,
  tooltipClassName,
  tooltipProps,
}: {
  children: React.ReactNode
  tooltip: string
  sideOffset?: number
  tooltipClassName?: string
  tooltipProps?: React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
}) {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          {...tooltipProps}
          className={cn(tooltipClassName, 'text-background z-[10000]')}
        >
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
